import PropTypes from 'prop-types';
import React from 'react';

export const COUNTRY_NAMES = {
  AU: 'Australia',
  CA: 'Canada',
  NZ: 'New Zealand',
  UK: 'the United Kingdom',
};

export const COUNTRY_NAME_ADJECTIVE = {
  AU: 'Australian',
  CA: 'Canadian',
  NZ: 'New Zealand',
  UK: 'UK',
};

const TermsAgreementMessage = ({ countryCode, practiceDisplay }) => {
  const DEFAULT_MESSAGE = (
    <React.Fragment>
      <strong>Required: </strong>I agree to the LocalMed{' '}
      <a href="/patient-terms" target="_blank" rel="noopener noreferrer">
        Terms of Use
      </a>{' '}
      and to receive electronic communications (including text messages) from {practiceDisplay}.
    </React.Fragment>
  );

  if (!countryCode || countryCode === 'US') {
    return DEFAULT_MESSAGE;
  }
  return (
    <div className="font-size-xs line-height-copy">
      {DEFAULT_MESSAGE} I understand by booking this appointment my information will be stored
      outside of {COUNTRY_NAMES[countryCode] || countryCode} in a manner that is compliant with{' '}
      {COUNTRY_NAME_ADJECTIVE[countryCode] || countryCode} and US health information protection
      laws. If you have any questions or concerns please call 225-590-3054.
    </div>
  );
};

TermsAgreementMessage.propTypes = {
  countryCode: PropTypes.string,
  practiceDisplay: PropTypes.string,
};

TermsAgreementMessage.defaultProps = {
  practiceDisplay: 'LocalMed',
};

export default TermsAgreementMessage;
